import React from 'react'
import { Box, Button, Grid, Typography} from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import AddIcon from '@mui/icons-material/Add';
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
import ActionButtons from '../../../components/ActionButtons';
import { useNavigate } from 'react-router-dom';

function CustomColumnMenu(props) {
  return (
      <GridColumnMenu
          {...props}
          slots={{
              // Hide `columnMenuColumnsItem`
              columnMenuColumnsItem: null,
              columnMenuSortItem: null,
          }}
      />
  );
}
const columns = [

  { field: 'No', headerName: 'No', editable: false, sortable: false,minWidth: 100 },
  { field: 'Inoice_Date', headerName: 'Inoice_Date', editable: false, sortable: false, minWidth: 100},
  { field: 'PreparedBy', headerName: 'Prepared By', editable: false, sortable: false, minWidth: 100 },
  { field: 'Owner', headerName: 'Owner', editable: false, sortable: false, flex: 1 , minWidth: 100},
  { field: 'VehicleNo', headerName: 'VRM', editable: false, sortable: false, flex: 1 , minWidth: 100},
  { field: 'TotalParts', headerName: 'Total Parts', editable: false, sortable: false, flex: 1,  minWidth: 100 },
  { field: 'TotalLabour', headerName: 'Total Labour', editable: false, sortable: false, flex: 1,  minWidth: 100 },
  { field: 'Total_Amount', headerName: 'Total Amount', editable: false, sortable: false,flex: 1,  minWidth: 100},
  { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 100, renderCell: (params) => {
    return (
    <ActionButtons title='Convert To Service Order' status={params.row.enstatus==='estimate'?true:false} page='/Invoice_Genaration'/>
    );
    }}
];

 

const rows = [

  { No: 1251, Inoice_Date: '01-02-2023', PreparedBy: 'William', Owner: 'Oliver Jake Jack Connor', VehicleNo:'KZ66 ZYT', TotalParts:2, TotalLabour:1, Total_Amount: 589},
  { No: 1252, Inoice_Date: '01-02-2023', PreparedBy: 'Jackson', Owner: 'John Fitzgerald Kennedy', VehicleNo:'OZ70 ZEV', TotalParts:2, TotalLabour:3, Total_Amount: 390},
  { No: 1253, Inoice_Date: '01-02-2023', PreparedBy: 'Sebastian', Owner: 'Alexander Anthony Benjamin', VehicleNo:'PZ65 PWO', TotalParts:5, TotalLabour:3, Total_Amount: 829},
  { No: 1254, Inoice_Date: '01-02-2023', PreparedBy: 'Michael' , Owner: 'Liam John Mason Robert', VehicleNo:'HZ13 WDD', TotalParts:2, TotalLabour:2, Total_Amount: 310},
  { No: 1255, Inoice_Date: '01-02-2023', PreparedBy: 'Alexander', Owner: 'Christopher Dominic Gabriel', VehicleNo:'PZ65 BYV', TotalParts:3, TotalLabour:3, Total_Amount: 256},
  ];
function Invoice() {
  const navigate = useNavigate()
  return (
    
    <Box mt={2}>
      <Grid container spacing={1}>
      <Grid item xs={12} >
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Typography sx={{ fontWeight: 'bold', fontSize: '18px' }}>INVOICE DETAILS</Typography>
          </Grid>
          <Grid item xs={6} display='flex' justifyContent='flex-end'>
          <Button sx={buttonStyle.root} onClick={() => navigate('/Invoice_Genaration')}><AddIcon />Add Invoice</Button>
            </Grid>
            </Grid>
            </Grid>
        <Grid item xs={12} mt={1}>
          <Box sx={dataGridStyle.root}>
            <DataGrid
              columnHeaderHeight={42}
              rowHeight={40}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.No}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[10]}
              slots={{ columnMenu: CustomColumnMenu }}
              disableRowSelectionOnClick
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Invoice